/**
 * Created by shem.mahluf on 06/09/2016.
 */
export default {
    GET_SSP_PERMISSIONS_LIST: 'GET_SSP_PERMISSIONS_LIST',
    SSP_PERMISSIONS_LIST: 'SSP_PERMISSIONS_LIST',
    GET_THEME: 'GET_THEME',
    THEME: 'THEME',
    FETCHING_COUNTER:'FETCHING_COUNTER',
    SET_IS_FETCHING:'SET_IS_FETCHING',
    IS_FETCHING:'IS_FETCHING',
    CLOSE_CHARGER:'CLOSE_CHARGER',
    STATUS_DISABLED:'1',
    STATUS_COMPLETED :'2',
    CAN_SEND_ANALYTICS:'CAN_SEND_ANALYTICS',
    GET_SSP_PREFERENCES: 'GET_SSP_PREFERENCES',
    SSP_PREFERENCES: 'SSP_PREFERENCES'
}



// WEBPACK FOOTER //
// ./constants/app.js